import { Button } from '@arco-design/web-react';
import { IconExclamationCircle } from '@arco-design/web-react/icon';

export interface RiskAlertCardProps {
  /** 上报标题（通知 data.title） */
  title: string;
  /** 上报正文：按换行拆行展示 */
  body?: string;
  /** 「查看通话」：停止标题闪烁 + 关闭卡片 + 跳转 CDR 详情（无 refID 落列表页） */
  onView: () => void;
}

/**
 * 高危风险上报大卡片（notify level=critical）：通知铃下方醒目红色卡片，
 * 无遮罩/ESC/右上角 X 关闭，必须点「查看通话」跳转 CDR 才消除；最新一条覆盖。
 *
 * 定位不在本组件里：它由 BasicLayout 的右上角浮层堆叠区（`.bcc-float-stack`）统一摆放，
 * 与素材整理进度胶囊纵向排列——两处各自写死 top 会在同时出现时叠在一起。
 */
export default function RiskAlertCard({ title, body, onView }: RiskAlertCardProps) {
  return (
    <div
      style={{
        width: 440,
        background: 'var(--color-bg-2)',
        border: '1px solid rgb(var(--danger-6))',
        borderLeft: '4px solid rgb(var(--danger-6))',
        borderRadius: 8,
        boxShadow: 'var(--bcc-shadow-float)',
        padding: 16,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
        <IconExclamationCircle style={{ color: 'rgb(var(--danger-6))', fontSize: 28, flexShrink: 0, marginTop: 2 }} />
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ color: 'rgb(var(--danger-6))', fontWeight: 600, fontSize: 16, marginBottom: 4 }}>
            高危风险上报
          </div>
          <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 4 }}>{title}</div>
          {body &&
            String(body)
              .split('\n')
              .filter((l) => l.trim())
              .map((line, i) => (
                <div key={i} style={{ fontSize: 13, color: 'var(--color-text-2)', marginBottom: 2, wordBreak: 'break-all' }}>
                  {line}
                </div>
              ))}
          <div style={{ marginTop: 12, textAlign: 'right' }}>
            <Button type="primary" status="danger" onClick={onView}>
              查看通话
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
